module.exports = __webpack_public_path__ + "99f448d505b490750f4beb02ffd61bb5.png";